import classNames from "classnames";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { FieldValueMetadata } from "../../../../common/types/dashboard/DashboardUITypes";
import { upsertFieldValues } from "../../../../db/fieldDBAction";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  // selectCurrentTab,
  selectFieldInEditMode,
  selectSelectedDocumentId,
  selectTextCopiedFromLHS,
  setFieldInEditMode,
  setTextCopiedFromLHS,
} from "../../../../redux/reducers/dashboardSlice";
import "./EditableValue.scss";
import { selectUserAppFontSize } from "../../../../redux/reducers/settingsSlice";
import { selectCustomLineHeight } from "../../../../redux/reducers/uiSlice";
import { updateDocumentFieldValue } from "../../../../redux/thunks";
import TickIcon from "../../../../assets/images/dialog/settings/blackTick.svg";
import TickIconDisabled from "../../../../assets/images/dashboard/table/SaveTickIcon_Disabled.svg";
import CrossIcon from "../../../../assets/images/dialog/settings/blackCross.svg";
import { selectReadOnlyApp } from "../../../../redux/reducers/appSlice";
import { selectAdjustFilter, setAdjustFilterPopup, setShowFilterAdjustPopup } from "../../../../redux/reducers/popupSlice";
// import { selectClients } from "../../../../redux/reducers/metadataSlice";
import { getFilterListForDocument, selectSelectedFilterChoices } from "../../../../redux/reducers/tabFilterSlice";
import states from "./states-constants";
import { CUSTOM_COLUMN_KEY } from '../../../../common/constants';
// import { fetchUserClientsDocuments } from "../../../../redux/reducers/documentsDataSlice";
// import { selectUserID } from "../../../../redux/reducers/userSlice";

function EditableValue(props: {
  field: FieldValueMetadata;
  isSelected: boolean;
  selectedField: string;
  docLoadingDone: boolean;
  handleNavigation: (fieldCode: string, fieldValue: string) => void;
  setFieldData:(fieldCode:string,fieldValue:string)=>void
}) {
  const isReadOnly = useAppSelector(selectReadOnlyApp);
  const selectedDocumentId = useAppSelector(selectSelectedDocumentId);
  const dispatch = useAppDispatch();
  const field = { ...props.field };
  const initialValue = field.value; // Original value before any edits
  const [isEditable, setIsEditable] = useState(false);
  const [fieldNewValue, setFieldNewValue] = useState(field.value);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const fieldInEditMode = useAppSelector(selectFieldInEditMode);
  const textCopied = useAppSelector(selectTextCopiedFromLHS);
  const [initCounter, setInitCounter] = useState(0);
  // const [isInbox,setIsInbox] = useState(false);
  // const activeFilterId = useAppSelector(selectCurrentTab);
  // const clients = useAppSelector(selectClients);
  // const selectedFilterChoices = useAppSelector(selectSelectedFilterChoices);
  // const userId = useAppSelector(selectUserID);
  // const [fetchdocs,setFetchDocs] = useState(false);
  const [fieldToFilterMap,setFieldToFilterMap] = useState<string[]>([]);
  const ajustFilter = useAppSelector(selectAdjustFilter);
  const [lf,setSlf] = useState(false);

  useEffect(()=>{
    dispatch(getFilterListForDocument({documentId:selectedDocumentId})).then((res)=>{
    const data = res.payload.data as { [key: string]: { fieldCode:string, isIncluded: boolean, included:boolean }[] };
    if(data && Object.values(data)[0]){
      const fields:string[] = Object.values(data)[0].map((each:any)=> {
        if(each.isIncluded === true){
          return each.fieldCode
        }
      }).filter(Boolean);
      setFieldToFilterMap(fields);      
    }});
  },[selectedDocumentId])


  useEffect(()=>{
    if(ajustFilter){
      saveAction(fieldNewValue);
      setFieldToFilterMap((prev)=>prev.filter((e) => e === props.field.field))
      dispatch(setAdjustFilterPopup(false))
    }
  },[ajustFilter])

  const handleKeyDown = (event: any) => {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    const newValue = event.target.value.trim();
    if (event.key === "Escape") {
      handleCancel();
    } else if (event.key === "Enter") {
      handleSave(newValue);
    }
  };

  const handleSave = (newValue: string) => {
    const fieldExistInOtherFilters = fieldToFilterMap.findIndex((each)=> each === props.field.field);
    if(fieldExistInOtherFilters !== -1){
      dispatch(setShowFilterAdjustPopup(true));
    } else {
      saveAction(!newValue?.trim()?"---":newValue);
    }
  };

  const saveAction = (newValue:string) =>{
    if (newValue !== initialValue) {
        // avoiding API call for State field if incorrect state is being sent;
        const currentField = props.field.field;
      if (currentField === "003m") {
        const normalizedInput = newValue.toLowerCase();
        const consolidatedState = states.find(
          (state) =>
            state.name.toLowerCase() === normalizedInput || state.abbr.toLowerCase() === normalizedInput
       );
        if (consolidatedState) {
        newValue = consolidatedState.name
        } else {
          handleCancel();
          return; 
        }
      } 
      upsertFieldValues({
        docId: selectedDocumentId,
        isPushed: false,
        fieldId: field.field,
        newValue: newValue,
        oldValue: initialValue,
        isPersisted: false,
      }).then(() => {
        dispatch(
          updateDocumentFieldValue({
            docId: selectedDocumentId,
            fieldCode: field.field,
            newValue: newValue,
            oldValue: initialValue,
            engineValue: field.engineValue,
          })
        )
      });
      // setFetchDocs(!fetchdocs)
      field.prevValue = initialValue;
      field.value = newValue;
    }
    setFieldNewValue(newValue);
    setIsEditable(false);
    dispatch(setFieldInEditMode(""));
    setSlf(false);
  }

  // useEffect(()=>{ 
  //   //refetches the document on change of value, this is a backend fix but needs to be done from frontend
  //   if(fetchdocs){
  //     setTimeout(()=>{
  //     dispatch(
  //       fetchUserClientsDocuments({
  //         clientIds: clients.map((client) => client.id),
  //         userId: userId.toString(),
  //       })
  //     );
  //     setFetchDocs(false);
  //   },300)
  //   }
  // },[fetchdocs])

  const handleCancel = () => {
    setFieldNewValue(initialValue); // Reset to original value
    setIsEditable(false);
    dispatch(setFieldInEditMode(""));
  };

  const handleDocumentClick: EventListener = (event) => {
    if (
      textareaRef.current &&
      event.target instanceof Node &&
      !textareaRef.current.contains(event.target)
    ) {
      handleSave(fieldNewValue.trim());
    }
  };

  const handleEditMode = (fieldCode: string) => {
    if (!isReadOnly) {
      setIsEditable(true);
      dispatch(setFieldInEditMode(fieldCode));
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
          textareaRef.current.select();
        }
      }, 100);
    }
  };

  useEffect(() => {
    if (
      props.docLoadingDone &&
      initCounter === 0 &&
      props.selectedField === props.field.field
    ) {
      setInitCounter((prev) => prev + 1);
      if (props.selectedField !== CUSTOM_COLUMN_KEY.EDIT_HIDDEN) {
        handleEditMode(props.selectedField);  
      }
    }
  }, [props.docLoadingDone]);

  const handleReset = () => {
    upsertFieldValues({
      docId: selectedDocumentId,
      isPushed: false,
      fieldId: field.field,
      newValue: field.engineValue,
      oldValue: initialValue,
      isPersisted: false,
    }).then(() => {
      dispatch(
        updateDocumentFieldValue({
          docId: selectedDocumentId,
          fieldCode: field.field,
          newValue: field.engineValue,
          oldValue: initialValue,
          engineValue: field.engineValue,
        })
      );
    });
    setFieldNewValue(field.engineValue);
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [fieldNewValue]);

  useEffect(() => {
    // if (field.field !== props.selectedField && initialValue !== fieldNewValue) {
    //   handleSave(fieldNewValue);
    // }
    if(field.field !== props.selectedField && lf){
      handleSave(fieldNewValue);
      setSlf(false);
    }
  }, [props.selectedField,props.field.field]);

  useEffect(() => {
    if (textCopied !== "" && props.isSelected) {
      setFieldNewValue(textCopied);
      handleSave(textCopied);
      dispatch(setTextCopiedFromLHS(""));
    }
  }, [textCopied]);

  const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setFieldNewValue(event.target.value);
    setSlf(true);
  };

  const userFontSize = Number(useAppSelector(selectUserAppFontSize).value);
  const userLineHeight = useAppSelector(selectCustomLineHeight);
  const customStyle = {
    cursor: "pointer",
    height: "auto",
    fontStyle: "normal",
    "--custom-text-font-size": userFontSize + "px",
    "--custom-line-height": userLineHeight,
  };

  const hasChanges = fieldNewValue.trim() !== initialValue;

  return (
    <>
      {<div className="value-holder">
        <div
          style={customStyle}
          className={classNames("value", {
            hide: isEditable && fieldInEditMode === props.field.field,
            "value-edited": props.field.engineValue !== fieldNewValue,
            "value-selected": props.isSelected,
            "value-not-selected": !props.isSelected,
          })}
          onClick={()=>{setIsEditable(false);props.handleNavigation(field.field, field.value)}}
          onDoubleClick={() => {handleEditMode(props.field.field)}}
        >
          {fieldNewValue}
        </div>
        {(!isReadOnly && fieldNewValue !== props.field.engineValue)  && <div
          key={props.field.engineValue}
          className={classNames("value-reset", {
            // hide: fieldNewValue === props.field.engineValue ,
          })}
          onClick={() => handleReset()}
        >
          Reset
        </div>}
      </div>}

      {<div
        className={classNames("value-textbox-container", {
          hide: !(isEditable && fieldInEditMode === props.field.field),
        })}
      >
        <textarea
          ref={textareaRef}
          className={classNames("value")}
          onChange={handleTextChange}
          onKeyDown={handleKeyDown}
          value={fieldNewValue}
        ></textarea>
        <div
          className={classNames("value-save-tick", {
            "value-tick-disabled": !hasChanges,
          })}
          onClick={() => hasChanges && handleSave(fieldNewValue.trim())}
        >
          <img src={hasChanges ? TickIcon : TickIconDisabled} alt="✓" />
        </div>
        <div
          className={classNames("value-save-cross")}
          onClick={handleCancel}
          title="Cancel"
        >
          <img src={CrossIcon} alt="✗" />
        </div>
      </div>}
    </>
  );
}
export default EditableValue;
